var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c("p", { staticClass: "export-tip" }, [
        _vm._v(_vm._s(_vm.$t("header.ChinaTime"))),
      ]),
      _c(
        "el-form",
        { attrs: { inline: true, "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.PlatformOrderID") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("common.PlatformOrderID") },
                model: {
                  value: _vm.searchInfo.PlatformOrderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "PlatformOrderNo", $$v)
                  },
                  expression: "searchInfo.PlatformOrderNo",
                },
              }),
            ],
            1
          ),
          _vm.$store.getters["user/merchantGrade"] === 1
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("common.MerchantID") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("common.MerchantID") },
                    model: {
                      value: _vm.searchInfo.MerchantId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchInfo, "MerchantId", $$v)
                      },
                      expression: "searchInfo.MerchantId",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.MerchantOrderNumber") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("common.MerchantOrderNumber") },
                model: {
                  value: _vm.searchInfo.MerchantOrderNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "MerchantOrderNo", $$v)
                  },
                  expression: "searchInfo.MerchantOrderNo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.ApplicationName") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("common.ApplicationName") },
                model: {
                  value: _vm.searchInfo.AppName,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "AppName", $$v)
                  },
                  expression: "searchInfo.AppName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.UserID") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("common.UserID") },
                model: {
                  value: _vm.searchInfo.UserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "UserId", $$v)
                  },
                  expression: "searchInfo.UserId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.PaymentChannel") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("common.PaymentChannel") },
                  model: {
                    value: _vm.searchInfo.PayMode,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchInfo, "PayMode", $$v)
                    },
                    expression: "searchInfo.PayMode",
                  },
                },
                _vm._l(_vm.methodList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "ChannelCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "ChannelCode" },
                model: {
                  value: _vm.searchInfo.ChannelCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "ChannelCode", $$v)
                  },
                  expression: "searchInfo.ChannelCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("search.OrderStatus") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("search.OrderStatus") },
                  on: {
                    change: function () {
                      _vm.searchInfo.OrderStatus = _vm.searchOption(
                        _vm.orderStatusObj,
                        _vm.orderStatus
                      )
                    },
                  },
                  model: {
                    value: _vm.orderStatus,
                    callback: function ($$v) {
                      _vm.orderStatus = $$v
                    },
                    expression: "orderStatus",
                  },
                },
                _vm._l(_vm.orderStatusObj, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.Country") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    placeholder: _vm.$t("common.Country"),
                  },
                  model: {
                    value: _vm.searchInfo.country,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchInfo, "country", $$v)
                    },
                    expression: "searchInfo.country",
                  },
                },
                _vm._l(_vm.countryList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.WhetherNotify") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("table.WhetherNotify") },
                  on: {
                    change: function ($event) {
                      _vm.searchInfo.notifyOk = _vm.Notify
                    },
                  },
                  model: {
                    value: _vm.Notify,
                    callback: function ($$v) {
                      _vm.Notify = $$v
                    },
                    expression: "Notify",
                  },
                },
                _vm._l(_vm.WhetherNotifySearch, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.lable },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("search.GatewayQuery") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("search.GatewayQuery") },
                model: {
                  value: _vm.searchInfo.GateWay,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "GateWay", $$v)
                  },
                  expression: "searchInfo.GateWay",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("common.GatewayID") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("common.GatewayID") },
                model: {
                  value: _vm.searchInfo.gateWayOrderID,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "gateWayOrderID", $$v)
                  },
                  expression: "searchInfo.gateWayOrderID",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Dispute ID" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Dispute ID" },
                model: {
                  value: _vm.searchInfo.disputeId,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "disputeId", $$v)
                  },
                  expression: "searchInfo.disputeId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "PayPal Capture ID" } },
            [
              _c("el-input", {
                attrs: { placeholder: "PayPal Capture ID" },
                model: {
                  value: _vm.searchInfo.captureId,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "captureId", $$v)
                  },
                  expression: "searchInfo.captureId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Dispute Status" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Dispute Status" },
                  on: {
                    change: function () {
                      _vm.searchInfo.disputeStatus = _vm.disputeStatusSelected
                    },
                  },
                  model: {
                    value: _vm.disputeStatusSelected,
                    callback: function ($$v) {
                      _vm.disputeStatusSelected = $$v
                    },
                    expression: "disputeStatusSelected",
                  },
                },
                _vm._l(_vm.disputeStatus, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "DisputeCheckStatus" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "DisputeCheckStatus" },
                  on: {
                    change: function () {
                      _vm.searchInfo.disputeCheckStatus =
                        _vm.disputeCheckStatusSelected
                    },
                  },
                  model: {
                    value: _vm.disputeCheckStatusSelected,
                    callback: function ($$v) {
                      _vm.disputeCheckStatusSelected = $$v
                    },
                    expression: "disputeCheckStatusSelected",
                  },
                },
                _vm._l(_vm.disputeCheckStatus, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "FraudStatus" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "FraudStatus" },
                  on: {
                    change: function () {
                      _vm.searchInfo.fraudStatus = _vm.fraudStatusSelected
                    },
                  },
                  model: {
                    value: _vm.fraudStatusSelected,
                    callback: function ($$v) {
                      _vm.fraudStatusSelected = $$v
                    },
                    expression: "fraudStatusSelected",
                  },
                },
                _vm._l(_vm.fraudStatus, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "PayPal Email" } },
            [
              _c("el-input", {
                attrs: { placeholder: "PayPal Email" },
                model: {
                  value: _vm.searchInfo.paypal_email,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "paypal_email", $$v)
                  },
                  expression: "searchInfo.paypal_email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Fingerprint" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Fingerprint" },
                model: {
                  value: _vm.searchInfo.fingerprint,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "fingerprint", $$v)
                  },
                  expression: "searchInfo.fingerprint",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Scheme" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Scheme" },
                model: {
                  value: _vm.searchInfo.scheme,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchInfo, "scheme", $$v)
                  },
                  expression: "searchInfo.scheme",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("search.CreationStartTime") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: _vm.$t("search.CreationStartTime"),
                },
                on: {
                  change: function ($event) {
                    return _vm.formatTimeOne(_vm.zeroTime, "start")
                  },
                },
                model: {
                  value: _vm.zeroTime,
                  callback: function ($$v) {
                    _vm.zeroTime = $$v
                  },
                  expression: "zeroTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("search.CreationEndTime") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: _vm.$t("search.CreationEndTime"),
                },
                on: {
                  change: function ($event) {
                    return _vm.formatTimeOne(_vm.currentTime, "end")
                  },
                },
                model: {
                  value: _vm.currentTime,
                  callback: function ($$v) {
                    _vm.currentTime = $$v
                  },
                  expression: "currentTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(_vm._s(_vm.$t("search.Inquire")))]
              ),
            ],
            1
          ),
          _vm.$store.getters["user/merchantGrade"] === 1
            ? _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.payInExcel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.Export")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.$store.getters["user/merchantGrade"] === 2
            ? _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.exportExcel("收款订单.xlsx", "#outTable")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.Export")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("p", { staticClass: "tip" }, [
        _vm._v(_vm._s(_vm.$t("header.CreationOrder"))),
      ]),
      _c("p", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.$t("header.eg")))]),
      _c("el-card", [
        _c("p", { staticClass: "staticsTip" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("header.Received")) +
                ": " +
                _vm._s(_vm.objData.successAmount)
            ),
          ]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("header.OrderNumber")) +
                ": " +
                _vm._s(_vm.objData.numberList)
            ),
          ]),
        ]),
      ]),
      _vm.$store.getters["user/merchantGrade"] === 1
        ? _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("table.CreationTime"),
                  prop: "CreateTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "155",
                  align: "center",
                  label: _vm.$t("table.CreationTimeLocal"),
                  prop: "CreateTimeLocal",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("common.ApplicationName"),
                  prop: "AppName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("common.UserID"),
                  prop: "UserID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "230",
                  align: "center",
                  label: _vm.$t("common.MerchantID"),
                  prop: "MerchantID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "250",
                  align: "center",
                  label: _vm.$t("common.PlatformOrderID"),
                  prop: "Id",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "220",
                  align: "center",
                  label: _vm.$t("common.MerchantOrderNumber"),
                  prop: "MerchantOrderID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "180",
                  align: "center",
                  label: _vm.$t("common.PaymentChannel"),
                  prop: "PayMode",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "110",
                  align: "center",
                  label: _vm.$t("common.Channel"),
                  prop: "GateWayType",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "170",
                  align: "center",
                  label: "ChannelCode",
                  prop: "ChannelCode",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "170",
                  align: "center",
                  label: "OrderType",
                  prop: "OrderType",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: _vm.$t("table.State"),
                  prop: "Status",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.Status === "success"
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v(_vm._s(scope.row.Status)),
                              ])
                            : scope.row.Status === "pending"
                            ? _c("el-tag", [_vm._v(_vm._s(scope.row.Status))])
                            : _c("el-tag", { attrs: { type: "danger" } }, [
                                _vm._v(_vm._s(scope.row.Status)),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1452677068
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: _vm.$t("common.Country"),
                  prop: "Country",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "270",
                  align: "center",
                  label: _vm.$t("common.Gateway"),
                  prop: "GateWayKey",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "300",
                  align: "center",
                  label: _vm.$t("common.GatewayID"),
                  prop: "GateWayOrderID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "300",
                  align: "center",
                  label: "Dispute ID",
                  prop: "DisputeID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "300",
                  align: "center",
                  label: "PayPal Capture ID",
                  prop: "CaptureID\n",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: "Dispute Status",
                  prop: "dispute_status",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getDisputeStatusLabel(
                                  scope.row.DisputeStatus
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2769772716
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: "Dispute Time",
                  prop: "DisputeTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "190",
                  align: "center",
                  label: "Dispute Time Local",
                  prop: "DisputeTimeLocal",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "Risk Grade",
                  prop: "RiskGrade",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getRiskGradeLabel(scope.row.RiskGrade)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1859260844
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  align: "center",
                  label: "TD Risk Grade",
                  prop: "TDRiskGrade",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getRiskGradeLabel(scope.row.TDRiskGrade)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4192019516
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "FraudStatus",
                  prop: "FraudStatus",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.FraudStatus
                            ? _c("span", [_vm._v("true")])
                            : _c("span", [_vm._v("false")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4191476839
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: "PayPal Email",
                  prop: "PaypalEmail",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "300",
                  align: "center",
                  label: "Fingerprint",
                  prop: "Fingerprint",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "Scheme",
                  prop: "Scheme",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("table.UpdateTime"),
                  prop: "UpDataTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "190",
                  align: "center",
                  label: _vm.$t("table.UpdateTimeLocal"),
                  prop: "UpDataTimeLocal",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "230",
                  align: "center",
                  label: _vm.$t("table.UserName"),
                  prop: "Name",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "260",
                  align: "center",
                  label: _vm.$t("table.Email"),
                  prop: "Email",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "100",
                  align: "center",
                  label: _vm.$t("table.Phone"),
                  prop: "Phone",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: _vm.$t("table.ReasonFailure"),
                  prop: "Reason",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: _vm.$t("table.OrderAmount"),
                  prop: "Amount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: _vm.$t("table.NumberNotifications"),
                  prop: "NotifyCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("table.WhetherNotify"),
                  prop: "NotifyOk",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.NotifyOk
                            ? _c("span", [_vm._v("true")])
                            : _c("span", [_vm._v("false")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3981025616
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "300",
                  align: "center",
                  label: _vm.$t("table.ForwardMessages"),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.Status === "success" ||
                          scope.row.Status === "fail" ||
                          scope.row.Status === "Paypal Pending"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.pushMessage(scope.row.Id)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("table.Forward")) + " ")]
                              )
                            : _vm._e(),
                          scope.row.Status === "success"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goBankAmount(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("table.Refund")) + " ")]
                              )
                            : scope.row.Status === "需要手动退款（后置风控）"
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goBankAmount(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("table.GoBack")) + " ")]
                              )
                            : !_vm.canShowManualChargeback(scope.row)
                            ? _c("span", [_vm._v("-")])
                            : _vm._e(),
                          _vm.canShowManualChargeback(scope.row)
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "warning" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openManualChargeback(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("手动chargeback ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1138750433
                ),
              }),
            ],
            1
          )
        : _vm.$store.getters["user/merchantGrade"] === 2
        ? _c(
            "el-table",
            { attrs: { id: "outTable", data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "150",
                  label: _vm.$t("table.CreationTime"),
                  prop: "CreateTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("table.CreationTimeLocal"),
                  prop: "CreateTimeLocal",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.$t("common.UserID"),
                  prop: "UserID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.$t("common.MerchantID"),
                  prop: "MerchantID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "290",
                  label: _vm.$t("common.PlatformOrderID"),
                  prop: "Id",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "170",
                  label: _vm.$t("common.MerchantOrderNumber"),
                  prop: "MerchantOrderID",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "90",
                  label: _vm.$t("table.State"),
                  prop: "Status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.Status === "success"
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(scope.row.Status)),
                            ])
                          : scope.row.Status === "pending"
                          ? _c("el-tag", [_vm._v(_vm._s(scope.row.Status))])
                          : _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(_vm._s(scope.row.Status)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "190",
                  label: _vm.$t("common.PaymentChannel"),
                  prop: "PayMode",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: "Dispute Status",
                  prop: "dispute_status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getDisputeStatusLabel(
                                scope.row.dispute_status
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: "Dispute Time",
                  prop: "disputeTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "190",
                  align: "center",
                  label: "Dispute Time Local",
                  prop: "chinaDisputeTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "Risk Grade",
                  prop: "RiskGrade",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getRiskGradeLabel(scope.row.RiskGrade)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "140",
                  align: "center",
                  label: "TD Risk Grade",
                  prop: "TDRiskGrade",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getRiskGradeLabel(scope.row.TDRiskGrade)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "FraudStatus",
                  prop: "FraudStatus",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.FraudStatus
                          ? _c("span", [_vm._v("true")])
                          : _c("span", [_vm._v("false")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "200",
                  align: "center",
                  label: "PayPal Email",
                  prop: "PaypalEmail",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "300",
                  align: "center",
                  label: "Fingerprint",
                  prop: "Fingerprint",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "120",
                  align: "center",
                  label: "Scheme",
                  prop: "Scheme",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "150",
                  label: "Updated Time",
                  prop: "UpDataTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  width: "150",
                  align: "center",
                  label: _vm.$t("table.UpdateTimeLocal"),
                  prop: "UpDataTimeLocal",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "150",
                  label: _vm.$t("table.ReasonFailure"),
                  prop: "Reason",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "100",
                  label: _vm.$t("table.OrderAmount"),
                  prop: "Amount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "100",
                  label: _vm.$t("table.WhetherNotify"),
                  prop: "NotifyOk",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.NotifyOk
                          ? _c("span", [_vm._v("true")])
                          : _c("span", [_vm._v("false")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "260",
                  align: "center",
                  label: _vm.$t("table.ForwardMessages"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.Status !== "success"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.pushMessage(scope.row.Id)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("table.Forward")) + " ")]
                            )
                          : _vm._e(),
                        _vm.canShowManualChargeback(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "warning" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openManualChargeback(scope.row)
                                  },
                                },
                              },
                              [_vm._v("手动chargeback ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          )
        : _vm._e(),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.page,
          "page-sizes": [10, 20, 30, 40, 100, 500, 1500],
          "page-size": _vm.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: { title: "退款", visible: _vm.goBankAmountVisble },
          on: {
            "update:visible": function ($event) {
              _vm.goBankAmountVisble = $event
            },
            close: _vm.clearGoBankAmountVisble,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "退款金额" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.goBankAmountData.Amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.goBankAmountData, "Amount", $$v)
                      },
                      expression: "goBankAmountData.Amount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.goBankAmountVisble = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goBankAmountConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "手动chargeback",
            visible: _vm.manualChargebackVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.manualChargebackVisible = $event
            },
            close: _vm.clearManualChargeback,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Id" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.manualChargebackData.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.manualChargebackData, "id", $$v)
                      },
                      expression: "manualChargebackData.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Dispute Status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Dispute Status" },
                      model: {
                        value: _vm.manualChargebackData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.manualChargebackData, "status", $$v)
                        },
                        expression: "manualChargebackData.status",
                      },
                    },
                    _vm._l(_vm.manualChargebackStatusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.manualChargebackVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmManualChargeback },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }